import React from "react";
import { MapPin, UserCheck, Layers, FileCheck } from "lucide-react";

const items = [
  { icon: MapPin, title: "Pan-India Coverage", text: "Exhibitions across every major Indian city." },
  { icon: UserCheck, title: "Single Point of Contact", text: "One dedicated project manager throughout." },
  { icon: Layers, title: "End-to-End Delivery", text: "Design through to post-show dismantling." },
  { icon: FileCheck, title: "Transparent Quotations", text: "Inclusions and exclusions confirmed in writing." },
];

export function TrustBand() {
  return (
    <section className="bg-white border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {items.map((it, i) => {
          const Icon = it.icon;
          return (
            <div key={i} className="flex items-start gap-4">
              <span className="shrink-0 w-11 h-11 rounded-xl bg-brand-soft flex items-center justify-center">
                <Icon className="text-brand" size={20} />
              </span>
              <div>
                <h3 className="font-display font-semibold text-charcoal text-[15px] mb-1">{it.title}</h3>
                <p className="text-sm text-body">{it.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
